<content class="margin-standard">
	<bfa-tabs [activate-on-mobile]="true">
		<tab-panel tab-title="Table" [templateRef]="table"></tab-panel>
		<tab-panel tab-title="Graph" [templateRef]="graph"></tab-panel>
	</bfa-tabs>
</content>
<ng-template #table>
	<dl-display-table class="col-12 col-sm-24" [data]="tab" [attr.data-cy]="tab?.config?.id + '-table'">
	</dl-display-table>
</ng-template>
<ng-template #graph>
	<bfa-chart [type]="type" [name]="name" [data]="tab" [hasFullHeight]="true" class="col-12 col-sm-24"
		[customAttributes]="customChartAttributes"></bfa-chart>
</ng-template>